import Swal from 'sweetalert2'
import {
    LOGIN_EMAIL,
    IS_LOADING_LOGIN_PASSWORD,
    NOT_LOADING_LOGIN_PASSWORD,
    LOGIN_EMAIL_PASSWORD,
    RECOVER_EMAIL
} from './types'
import {
    urlServer
} from '../config/GlobalConstant'
import {
    sendEmailToPassword
} from '../actions/recoverActions'
import socketLogic from '../sockets/sockets';
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
//login email and how to get code actions

export const loginEmailPassword = (email, password, history) => async dispatch => {

    console.log();
    dispatch({
        type: IS_LOADING_LOGIN_PASSWORD
    })

    await fetch(`${urlServer}static-routes/login`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        //  withCredentials: true,
        // credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            //'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            password: password,
            email: email
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {

            dispatch({
                type: NOT_LOADING_LOGIN_PASSWORD
            });

            if (!respJson.success){
                if(respJson.error.code==="MSJ010"){
                    Toast.fire({
                        text:"El correo o la contraseña son incorrectos",
                        icon:"error"
                    })
                }
                if(respJson.error.code==="ERR058"){
                    Toast.fire({
                        text:"Debe iniciar sección por Google o Facebook",
                        icon:"error"
                    })
                }
            }

            console.log()
            const errorType = respJson.error;

            if (respJson.data.token) {
                inMemoryJWT.setToken(respJson.data.token.token, respJson.data.token.expirationTimeToken)
                const accessToken = inMemoryJWT.getToken()

            }

            if (respJson.data.type === "user") {
                {
                   
                    localStorage().setItem("nameUser", respJson.data.name)
                    localStorage().setItem("lastNameUser", respJson.data.lastname)      
                    localStorage().setItem("idProfile", respJson.data._id)
                    localStorage().setItem("typeProfile", "user")
                    localStorage().setItem("idUser", respJson.data._id)
                    let picture;
                    if(respJson.data.picture){
                        picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;
                    
                    }else{
                        picture = ""
                    
                    }
                   localStorage().setItem("picturProfile", picture)
                    localStorage().setItem("typeUser", respJson.data.type)
             
                    socketLogic.userConnect(localStorage().getItem('idProfile'))

                }
            }
            dispatch({
                type: LOGIN_EMAIL_PASSWORD,
                payload: {
                    password,
                    email,
                    errorType
                }
            });
            if (respJson.success === true && respJson.error === null && respJson.data.type === "user") {
                //history.replace ('/')   
                localStorage().setItem("statusLog", true);
                history.go (0)   
                
            } 
           
        })
        .catch(error => {
            console.log();
        })
}
export const loginEmailPasswordAdmin = (email, password, history) => async dispatch => {

    console.log();
    dispatch({
        type: IS_LOADING_LOGIN_PASSWORD
    })

    await fetch(`${urlServer}static-routes/login/eco-admin`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        //  withCredentials: true,
        // credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            //'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            password: password,
            email: email
        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {

            dispatch({
                type: NOT_LOADING_LOGIN_PASSWORD
            });

            if (!respJson.success){
                if(respJson.error.code==="MSJ010"){
                    Toast.fire({
                        text:"El correo o la contraseña son incorrectos",
                        icon:"error"
                    })
                }
            }

            console.log()
            const errorType = respJson.error;

            if (respJson.data.token) {
                inMemoryJWT.setToken(respJson.data.token.token, respJson.data.token.expirationTimeToken)
                const accessToken = inMemoryJWT.getToken()
            }

            if (respJson.data.type === "admin") {
                {
                    localStorage().setItem("nameUser", respJson.data.name)
                    localStorage().setItem("lastNameUser", respJson.data.lastname)

                    localStorage().setItem("idUser", respJson.data._id)
                    localStorage().setItem("idProfile", respJson.data._id)
                    let picture;
                    if(respJson.data.picture){
                        picture = respJson.data.picture.url ? respJson.data.picture.url.small ? respJson.data.picture.url.small : respJson.data.picture.url.origin : respJson.data.picture;
                    
                    }else{
                        picture = ""
                    
                    }
                   localStorage().setItem("picturProfile", picture)
                    localStorage().setItem("typeUser", "admin")
                 
                    socketLogic.userConnect(localStorage().getItem('idProfile'))
                    localStorage().setItem("statusLog", true);
                    history.push('/Admin')

                }
            }
            dispatch({
                type: LOGIN_EMAIL_PASSWORD,
                payload: {
                    password,
                    email,
                    errorType
                }
            });
        })
        .catch(error => {
            console.log();
        })
}
export const loginEmail = (email, password, history) => async dispatch => {
    console.log()
    console.log()
    dispatch({
        type: IS_LOADING_LOGIN_PASSWORD
    });
    await fetch(`${urlServer}static-routes/login`, {

        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        //   withCredentials: true,
        // credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            //'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            email: email,
            password: password

        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            //if(respJson.data.name){var nameUser=respJson.data.name}
            // else{
            //     var nameUser=respJson.data.socialReason  
            // }
            var model = respJson.data && respJson.data.type
            var errorType = respJson.error || {}
            var data = respJson.data || []
            var type = ''
            if (respJson.data) {
                if (respJson.data.type === 'marks') {
                    type = 'mark'
                    console.log()
                }
            }

            dispatch({
                type: LOGIN_EMAIL,
                payload: {
                    errorType,
                    data,
                    email,
                    type
                }
            });


            if (errorType) {



            }


            if (errorType !== null && errorType.code === "ERR053") {
                dispatch({
                    type: RECOVER_EMAIL,
                    payload: {
                        errorType,
                        data,
                        email,
                        type
                    }
                });
                history.push({
                    pathname: '/RecoverPasswordCode',
                    state: {
                        email: email
                    }
                })

            }

        


            if (respJson.success === true && respJson.data !== null) {
                console.log()
                history.push({
                    pathname: '/',
                    state: {
                        email: email
                    }
                })
            }


            if (respJson.success === false && respJson.data !== null && respJson.error.code === 'ERR063') {


                Toast.fire({
                    icon: 'success',
                    title: 'Se ha enviado un código de verificación a tu correo'
                })

                history.push({
                    pathname: '/RecoverPasswordCode',
                    state: {
                        email: email,
                        model: respJson.data.type
                    }
                })
            }



            if (respJson.success === true && respJson.data !== null && respJson.data.message === "Se ha enviado un código de verificación al correo " + email && respJson.error === null) {

                Toast.fire({
                    icon: 'success',
                    title: 'Se ha enviado un código de verificación a tu correo para completar tu registro'
                })
                history.push({
                    pathname: '/RegisterCodeVerification',
                    state: {
                        email: email,
                        model: respJson.data.data.type
                    }
                })
            }

        })
        .catch(error => {
            console.log()
        })
}